/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cal_3_WInputs */

const en_cp_cal_3_w = /** @type {(inputs: Cp_Cal_3_WInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weeks 3–6`)
};

const id_cp_cal_3_w = /** @type {(inputs: Cp_Cal_3_WInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minggu 3–6`)
};

/**
* | output |
* | --- |
* | "Weeks 3–6" |
*
* @param {Cp_Cal_3_WInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cal_3_w = /** @type {((inputs?: Cp_Cal_3_WInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cal_3_WInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cal_3_w(inputs)
	return en_cp_cal_3_w(inputs)
});